import { LocalDateType } from '@app/models';
import { FilterType, SharedOption } from '@app/pcs/models';
import { DossierSearchCriteria, dossierSearchCriteria } from '@app/pcs/models/dossier-search-criteria';
import { gql } from 'apollo-angular';

export interface Filter {
  id?: number;
  name?: string;
  dossierSearchModel?: DossierSearchCriteria;
  validTo?: LocalDateType;
  validFrom?: LocalDateType;
  filterType?: FilterType;
  creatorId?: number;
}

export interface UserFilter {
  filter?: Filter;
  sortOrder?: number;
  selected?: boolean;
  editable?: boolean;
  sharedType?: SharedOption;
  displaySettings?: string;
  hidden?: boolean;
}

export const filter = gql`
  fragment filter on Filter {
    id
    name
    validTo
    validFrom
    filterType
    dossierSearchModel {
      ttp {
        id
      }
      myProgressStatuses {
        id
        description
      }
      progressStatuses {
        id
        description
      }
      dossierStatuses {
        id
        description
      }
      processTypes {
        id
        description
      }
    }
  }
`;

export const filterWithCriteriaDetailed = gql`
  fragment filterWithCriteriaDetailed on Filter {
    id
    name
    validTo
    validFrom
    filterType
    dossierSearchModel {
      ...dossierSearchCriteria
    }
  }
  ${dossierSearchCriteria}
`;

export const userFilter = gql`
  fragment userFilter on UserFilter {
    filter {
      ...filter
    }
    editable
    sortOrder
    sharedType
    displaySettings
    hidden
    userId
  }
  ${filter}
`;

export const userFilterWithSearchCriteriaDetailed = gql`
  fragment userFilterWithSearchCriteriaDetailed on UserFilter {
    filter {
      ...filterWithCriteriaDetailed
    }
    editable
    sortOrder
    sharedType
    displaySettings
    hidden
  }
  ${filterWithCriteriaDetailed}
`;

